import {BaseCopyStamp} from '../../utils/BaseCopyStamp';

export class CopyStamp extends BaseCopyStamp {}
